/* ============
 * waiting to be processed
 * ============
 *
 */
import { mapGetters } from 'vuex';
import userWidgetsService from './../../../services/widgets';

export default {

    data() {
        return {
            number: 0,
            loaded: false,
        };
    },

    computed: {
        ...mapGetters({
            waitingProcessedWidgets: 'waitingProcessedWidgets',
        }),
    },

    watch: {
      waitingProcessedWidgets(waitingProcessedWidgets) {
          this.number = waitingProcessedWidgets.items;
          this.loaded = true;
        },
      },

    methods: {
        initializeWidgets() {
            Promise.all([
              userWidgetsService.fetchWaitingProcessedWidgets(),
            ]).then(() => {
              this.number = this.waitingProcessedWidgets.items;
              this.loaded = true;
            });
          },
    },

    created() {
        this.initializeWidgets();
    }

};



// WEBPACK FOOTER //
// ./src/app/components/widgets/waitingProcessed/waitingProcessed.js